import { useState, useEffect } from "react";
import { buscarPostagemByIdService } from "../../../services/buscarPostagemByIdService";

export const useBuscarPostagem = (postagemId: number, isModalOpen: boolean) => {
  const [postagem, setPostagem] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      if (!isModalOpen || !postagemId) {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const data = await buscarPostagemByIdService(postagemId);
        setPostagem(data);
      } catch (error) {
        console.error("Erro ao buscar postagem:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, [isModalOpen, postagemId]);

  return { postagem, isLoading };
};
